<template>
  <div>
    <v-container>
      <h1 class="primary--text font-weight-bold pb-4">
        {{
          !isEditPromotion
            ? $t("settings.promotionCharge.addNew")
            : $t("settings.promotionCharge.update")
        }}
      </h1>
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form v-on:submit.prevent="handleSubmit(onSave)" :key="reRender">
          <v-row align="center">
            <v-col cols="12" sm="6" md="6" class="py-0 pt-6">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-autocomplete
                  v-model="propertyId"
                  :error-messages="errors"
                  :items="propertyTypeLists"
                  item-text="nameEn"
                  item-value="_id"
                  :search-input.sync="search"
                  outlined
                  dense
                  :label="$t('property.unit.property')"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("property.unit.property") }}
                  </template></v-autocomplete
                >
              </ValidationProvider>
            </v-col>
            <!-- <v-col cols="12" sm="6" v-if="!isEditPromotion" md="6" class="py-0 pt-6">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-select
                  v-model="basedPrice"
                  :error-messages="errors"
                  :items="[ 'Default Price', 'Set Price' ]"
                  :search-input.sync="search"
                  outlined
                  dense
                  :label="`Price`"
                ></v-select>
              </ValidationProvider>
            </v-col> -->
            <v-col cols="12" sm="6" md="6" class="py-0 pt-6">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="$t('landlordValidityPlan.price')"
                  color="secondary"
                  type="text"
                  v-model="price"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span>
                    <span>{{ $t("settings.promotionCharge.price") }}</span>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="8" sm="8" md="8" class="mx-auto">
              <!-- <div class="d-flex justify-space-around"> -->
              <!-- <v-btn class="custom-button text-none" @click="onCancel">
                {{ $t('common.cancel')}}
                </v-btn> -->
              <v-btn
                width="100%"
                class="white--text rounded-lg"
                color="primary"
                type="submit"
                :loading="btnLoading"
              >
                {{ isEditPromotion ? $t("common.update") : $t("common.save") }}
              </v-btn>
              <!-- </div> -->
            </v-col>
            <v-col v-if="isError != null" cols="12" sm="12"
              ><Alert :message="isError" />
            </v-col>
          </v-row>
        </form>
      </ValidationObserver>
    </v-container>
  </div>
</template>
<script>
import "@/core/methods/validation_rules";
import { mapGetters } from "vuex";
import { createPromotinCharges } from "../../methods/fee/create_fee";
import { updatePromotionCharge } from "../../methods/fee/update_fee";
export default {
  data() {
    return {
      search: "",
      reRender: 0,
      btnLoading: false,
      price: null,
      isError: null,
      propertyTypeLists: [],
      propertyId: null,
      updateId: null,
      basedPrice: "Default Price",
      defaultPrice: null
    };
  },
  components: {
    Alert: () => import("@/core/components/Alert.vue")
  },
  mounted() {
    if (this.isEditPromotion) {
      const updateInput = this.$format.cloneVariable(this.editPromotion);
      this.propertyId = updateInput.propertyType._id;
      this.price = updateInput.price;
      this.updateId = updateInput._id;
      this.basedPrice = "Set Price";
    }
  },
  computed: {
    ...mapGetters(["isEditPromotion", "editPromotion"])
  },
  watch: {
    basedPrice() {
      this.price =
        this.basedPrice === "Default Price" ? this.defaultPrice : this.price;
    },
    isEditPromotion: {
      handler() {
        if (this.isEditPromotion) {
          const updateInput = this.$format.cloneVariable(this.editPromotion);
          this.propertyId = updateInput.propertyType._id;
          this.price = updateInput.price;
          this.updateId = updateInput._id;
          this.basedPrice = "Set Price";
        } else {
          this.propertyId = "";
          this.price = "";
          this.updateId = "";
          this.reRender++;
          this.basedPrice = "Default Price";
        }
      },
      deep: true
    }
  },
  apollo: {
    getDefaultPromotionCharge() {
      this.loading = true;
      return {
        query: require("@/settings/api/queries/fee/default_promotion_charge_query.graphql"),
        result({ data }) {
          // , loading, networkStatus, refetch
          this.defaultPrice = data.getDefaultPromotionCharge;
          if (!this.isEditPromotion) this.price = this.defaultPrice;
          this.loading = false;
        }
      };
    },
    getPropertyTypes() {
      return {
        query: require("@/property/api/queries/propertyType/property_type_query.graphql"),
        variables: {
          input: {
            limit: 0,
            skip: 0
          },
          filter: {
            searchKey: this.search
          }
        },
        result({ data }) {
          // , loading, networkStatus, refetch
          this.propertyTypeLists = this.$format.cloneVariable(
            data.getPropertyTypes.PropertyTypes
          );
        }
      };
    }
  },
  methods: {
    async onSave() {
      this.btnLoading = true;
      const input = {
        input: {
          propertyType: this.propertyId,
          price: Number(this.price)
        }
      };
      if (!this.isEditPromotion) {
        createPromotinCharges(input).then(response => {
          if (response.data) {
            this.btnLoading = false;
            // this.$root.$emit('refetchArea')
            this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.saveSuccess"),
              color: "green"
            });
            this.propertyId = null;
            this.price = null;
            this.reRender++;
          }
          if (response.graphQLErrors) {
            this.btnLoading = false;
            this.isError = response.graphQLErrors[0].message;
            setTimeout(() => {
              this.isError = null;
            }, 5000);
          }
        });
      } else {
        const updateInput = {
          promotionChargeId: this.updateId,
          input: {
            propertyType: this.propertyId,
            price: Number(this.price)
          }
        };
        updatePromotionCharge(updateInput).then(response => {
          if (response.data) {
            this.$root.$emit("refetchFee");
            this.btnLoading = false;
            this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
            this.$store.commit("IS_EDIT_PROMOTION", false);
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.updateSuccess"),
              color: "green"
            });
          }
          this.reRender++;
          if (response.graphQLErrors) {
            this.btnLoading = false;
            this.isError = response.graphQLErrors[0].message;
          }
        });
      }
    }
    // onCancel() {
    //   this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
    //   this.$store.commit("IS_EDIT_PROMOTION", false);
    // },
  }
};
</script>
